import { CustomerModel } from '../shared/models/customer-model';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { CustomerStatusEnum } from '../shared/models/customer-status.enum';

@Component({
  selector: 'hr-customer-billing',
  templateUrl: './customer-billing.component.html',
  styleUrls: ['./customer-billing.component.less'],
  standalone: false,
})
export class CustomerBillingComponent implements OnInit {
  @Input()
  public customer: CustomerModel;

  public customerStatusEnum: any = CustomerStatusEnum;

  constructor() {}

  ngOnInit() {}
}
